<template>
  <div>
    <Form
      ref="form"
      class="RealisationDetail PageWrapper DetailGrid"
      @error="handleValidationError"
      @submit="handleSubmit"
    >
      <RealisationHeader
        :record="record"
        :feedback="feedback"
        :feedback-message="feedbackMessage"
        :step="currentStep"
        :record-step="step"
      >
        <FlowInteraction
          position="top"
          :first="currentStep === 1"
          :step="step"
          :current-step="currentStep"
          :locked="locked"
          :disabled="disabled"
          :completed="completed"
          :is-completed-step="isCompletedStep"
          :disable-next-btn="disableNextBtn"
          :may-edit="mayEdit"
          :open-for-change="openForChange"
          @handleNext="handleNext"
          @handlePrevious="handlePrevious"
          @handleSubmitAndNext="handleSubmitAndNext"
          @handleCancelChange="handleCancelChange"
          @handleStartCorrection="handleStartCorrection"
          @handleStartChange="handleStartChange"
          @handleComplete="handleComplete"
        />
      </RealisationHeader>

      <RealisationSidebar
        :uuid="uuid"
        :disabled="disabled || locked"
      />

      <div class="DetailGrid__map">
        <StepFormFields
          :values="values"
          :disabled="locked || disabled"
        />
      </div>

      <RealisationFooter
        :feedback="feedback"
        :feedback-message="feedbackMessage"
      >
        <FlowInteraction
          position="bottom"
          :first="currentStep === 1"
          :step="step"
          :current-step="currentStep"
          :locked="locked"
          :disabled="disabled"
          :completed="completed"
          :is-completed-step="isCompletedStep"
          :disable-next-btn="disableNextBtn"
          :may-edit="mayEdit"
          :open-for-change="openForChange"
          @handleNext="handleNext"
          @handlePrevious="handlePrevious"
          @handleSubmitAndNext="handleSubmitAndNext"
          @handleCancelChange="handleCancelChange"
          @handleStartCorrection="handleStartCorrection"
          @handleStartChange="handleStartChange"
          @handleComplete="handleComplete"
        />
      </RealisationFooter>
    </Form>
    <Comments :record="record" />
  </div>
</template>

<script>


import RealisationHeader from '@/components/realisation/RealisationHeader'
import RealisationFooter from '@/components/realisation/RealisationFooter'
import RealisationSidebar from '@/components/realisation/RealisationSidebar'

import Form from '@/components/form/Form'

import Comments from '@/components/Comments'

import BaseRealisationStep from '@/views/BaseRealisationStep'

import FlowInteraction from '@/components/flow/FlowInteraction.vue'

// RVB
import StepFormFields from '@/components/definitions/rvb/step_3/Assess_Power_Possibilities_II.vue'

export default {
  name: 'RealisationDetail3',
  components: {
    RealisationSidebar, RealisationHeader, RealisationFooter,
    Form,
    Comments,

    FlowInteraction,

    // RVB
    StepFormFields,
  },
  mixins: [BaseRealisationStep],
  data() {
    return {
      currentStep: '3-e',
    }
  },
}
</script>
